<script>
    import {colors} from '../store';
    export let markings;
    export let animatedPosition;
    export let animatedDirection;
</script>

<g transform="rotate({animatedDirection.value.degrees}, {animatedPosition.centre.x}, {animatedPosition.centre.y})
    translate({animatedPosition.x}, {animatedPosition.y})
    scale(.7)"
>
    <rect x="0" y="0" width="1" height="1" fill="{$colors.red[900]}" />
    {#each markings as {x, y, width, height}}
        <rect x="{x}" y="{y}" width="{width}" height="{height}" fill="{$colors.red[800]}" />
    {/each}
    <circle cx=".2" cy=".2" r=".1" fill="{$colors.red[100]}" />
    <circle cx=".8" cy=".2" r=".1" fill="{$colors.red[100]}" />
    <!-- {#each commands as {symbol}, j}
        <rect x="{animatedPosition.x + j *.3}" y="{animatedPosition.y - .2}" width=".2" height=".2" rx=".05" fill="{$colors.red[800]}" />
        <use xlink:href="#{symbol}" x="{animatedPosition.x + .025 + j *.3}" y="{animatedPosition.y - .18}" width=".15" height=".15" />
    {/each} -->
</g>
